import { render } from "./PrizesPopup.vue?vue&type=template&id=1a9e75be&scoped=true"
import script from "./PrizesPopup.vue?vue&type=script&lang=js"
export * from "./PrizesPopup.vue?vue&type=script&lang=js"

import "./PrizesPopup.vue?vue&type=style&index=0&id=1a9e75be&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9e75be"]])

export default __exports__